import {
    TMaintenancePackageInitialState,
    TMaintenancePackagePayloads,
} from '../types';

export const updateMaintenancePackageState = (
    state: TMaintenancePackageInitialState,
    payload: TMaintenancePackagePayloads
) => ({
    ...state,
    loading: false,
    error: null,
    ...payload,
});
